<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card bg-white border-round">
    <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
      <div class="flex w-full items-center">
        <h2 class="m-0">Claims Calculation Results</h2>
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Search"
          icon="pi pi-check"
          (click)="submitForm('search')"
          [loading]="isLoading"
        ></p-button>

        <!-- <p-button
          label="Generate ({{ listCount }})"
          icon="pi pi-check"
          [loading]="isLoading"
          [disabled]="!hasNewStatus()"
          (click)="togglePopup(true)"
        ></p-button> -->

        <!-- <p-button
          label="Generate Selected ({{ selectedLineIds.length }})"
          icon="pi pi-check"
          [loading]="isLoading"
          [disabled]="!hasNewStatus()"
          (click)="togglePopup(true, 'selected')"
        ></p-button> -->

        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>

        <p-button
          label="Preview CM PDF"
          icon="pi pi-file-pdf"
          styleClass="p-button-danger"
          [disabled]="
            !filterForm.controls['supplier'].value ||
            !filterForm.controls['claimSeqNumber'].value
          "
          (click)="previewCreditMemoPdf()"
        ></p-button>

        <span #actionsMenuTarget class="inline-flex">
          <p-button
            type="button"
            label="Actions"
            icon="pi pi-bars"
            (click)="updateActionItems(); menu.toggle($event)"
            [loading]="isLoading"
          ></p-button>
          <p-menu
            #menu
            [model]="actionItems"
            [popup]="true"
            [appendTo]="'body'"
            [baseZIndex]="1100"
          ></p-menu>
        </span>

      </div>
    </div>
    <div class="card-body p-2">
      <form
        [formGroup]="filterForm"
        novalidate
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="off"
      >
        <div class="grid formgrid p-fluid">
          <!-- supplier required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredSuppliers"
                  formControlName="supplier"
                  inputId="supplier"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [ngClass]="{ 'p-invalid': isInvalid('supplier') }"
                  (onChange)="
                    onSupplierChange(filterForm.controls['supplier'].value)
                  "
                >
                  <ng-template let-supplier pTemplate="selectedItem">
                    <div *ngIf="supplier">
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template let-supplier pTemplate="item">
                    <div>
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-supplier>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #supplierInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterSuppliers($event)"
                        value="{{ SupplierfilterValue }}"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="supplier"
                  >Supplier<span class="requiredLable">*</span></label
                >
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['supplier'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- business required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredBusiness"
                  formControlName="business"
                  inputId="business"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-business pTemplate="selectedItem">
                    <div *ngIf="business">
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template let-business pTemplate="item">
                    <div>
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-business>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #businessInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterBusinesses($event)"
                        value="{{ BusinessfilterValue }}"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="business">Business</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['business'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- process status required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="processStatus"
                  formControlName="claimStatus"
                  optionLabel="label"
                  optionValue="value"
                  inputId="claimStatus"
                  class="w-full"
                  placeholder="Select Claim Status"
                  [required]="true"
                  [ngClass]="{ 'p-invalid': isInvalid('claimStatus') }"
                ></p-dropdown>
                <label for="claimStatus"
                  >Process Status<span class="requiredLable">*</span></label
                >
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <!-- source -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-list"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="sourceOptions"
                  formControlName="source"
                  optionLabel="label"
                  optionValue="value"
                  inputId="source"
                  class="w-full"
                  placeholder="Select Source"
                ></p-dropdown>
                <label for="source">Source</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['source'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>


          <!-- start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDate"
                  [showIcon]="true"
                  inputId="startDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="startDate">Activity Start Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['startDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="endDate"
                  [showIcon]="true"
                  inputId="endDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [minDate]="filterForm.get('startDate')?.value"
                ></p-datePicker>
                <label for="endDate">Activity End Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['endDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- contract type  required
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="contractTypes"
                  formControlName="contractType"
                  optionLabel="label"
                  optionValue="label"
                  inputId="contractType"
                  class="w-full"
                  placeholder="Select Contract Type"
                ></p-dropdown>
                <label for="contractType">Contract Type</label>
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['contractType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div> -->
           <!-- activity type -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredActivityTypes"
                  formControlName="activityType"
                  inputId="activityType"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-activityType pTemplate="selectedItem">
                    <div *ngIf="activityType">
                      {{ activityType.name }}
                    </div>
                  </ng-template>
                  <ng-template let-activityType pTemplate="item">
                    <div>
                      {{ activityType.name }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-activityType>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #activityTypeInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterActivityTypes($event)"
                        value="{{ activityTypefilterValue }}"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="activityType">Activity Type</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['activityType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- rebate trx start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="rebateTrxStartDate"
                  [showIcon]="true"
                  inputId="rebateTrxStartDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="rebateTrxStartDate"
                  >Rebate Transaction Start Date</label
                >
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['rebateTrxStartDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- rebate trx end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="rebateTrxEndDate"
                  [showIcon]="true"
                  inputId="rebateTrxEndDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [minDate]="filterForm.get('rebateTrxStartDate')?.value"
                ></p-datePicker>
                <label for="rebateTrxEndDate"
                  >Rebate Transaction End Date</label
                >
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['rebateTrxEndDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="rebateTrxNumber"
                  id="rebateTrxNumber"
                  class="w-full"
                  placeholder="AR Transaction Number"
                  [ngClass]="{ 'p-invalid': isInvalid('rebateTrxNumber') }"
                />
                <label for="rebateTrxNumber">AR Transaction#</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="claimNumber"
                  id="claimNumber"
                  class="w-full"
                  placeholder="AP Transaction Number"
                  [ngClass]="{ 'p-invalid': isInvalid('claimNumber') }"
                />
                <label for="claimNumber">AP Transaction#</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="refInvoice"
                  id="refInvoice"
                  class="w-full"
                  placeholder="Referance Invoice Number"
                  [ngClass]="{ 'p-invalid': isInvalid('refInvoice') }"
                />
                <label for="refInvoice">Referance Invoice#</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="claimSeqNumber"
                  id="claimSeqNumber"
                  class="w-full"
                  placeholder="Claim Seq Number"
                  [ngClass]="{ 'p-invalid': isInvalid('claimSeqNumber') }"
                />
                <label for="claimSeqNumber"
                  >Claim Seq Number<span
                    class="requiredLable"
                    *ngIf="claimSeqNumberRequired"
                    >*</span
                  ></label
                >
              </p-iftalabel>
              <p-inputgroup-addon
                ><p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['claimSeqNumber'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button
              ></p-inputgroup-addon>
            </p-inputgroup>
          </div>
        </div>
      </form>
    </div>
    <div class="flex justify-end ml-1">
      <div class="border-1 border-gray-200 bg-white border-round p-2">
        <span class="mr-2">Total Claim Amount:</span>
        <span>{{ totalClaimAmt | number: "1.2-2" }}</span>
      </div>
    </div>
  </div>

  <div class="card mt-2">
    <p-table
      #dt
      [value]="claimCalculations"
      [(selection)]="selectedCalculations"
      (selectionChange)="onSelectionChange($event)"
      selectionMode="multiple"
      [rows]="30"
      [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100, 500]"
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadClaimCalculations($event)"
      [loading]="isLoading"
      [lazy]="true"
      dataKey="lineId"
      styleClass="p-datatable-striped overflow-x-auto"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <ng-container *ngIf="canShowHeaderCheckbox()">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </ng-container>
          </th>
          <th>Line Number</th>
          <th pSortableColumn="vendorNumber">
            Vendor Number<p-sortIcon field="vendorNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="businessNumber">
            Business <p-sortIcon field="businessNumber"></p-sortIcon>
          </th>


          <th pSortableColumn="claimStatus">
            Claim Status <p-sortIcon field="claimStatus"></p-sortIcon>
          </th>
          <th pSortableColumn="claimBatchId">
            Claim Batch ID <p-sortIcon field="claimBatchId"></p-sortIcon>
          </th>
          <th>Error Message</th>
          <th pSortableColumn="source">
            Source <p-sortIcon field="source"></p-sortIcon>
          </th>
          <th pSortableColumn="type">
            Type <p-sortIcon field="type"></p-sortIcon>
          </th>
          <th pSortableColumn="period">
            Period <p-sortIcon field="period"></p-sortIcon>
          </th>
          <th pSortableColumn="contractNo">
            Contract No <p-sortIcon field="contractNo"></p-sortIcon>
          </th>
          <th pSortableColumn="customerNumber">
            Customer <p-sortIcon field="customerNumber"></p-sortIcon>
          </th>
          <th>Address 1</th>
          <th>Address 2</th>
          <th pSortableColumn="area">
            Area <p-sortIcon field="area"></p-sortIcon>
          </th>
          <th pSortableColumn="city">
            City <p-sortIcon field="city"></p-sortIcon>
          </th>
          <th pSortableColumn="refInvoice">
            Ref Invoice <p-sortIcon field="refInvoice"></p-sortIcon>
          </th>
          <th pSortableColumn="refInvDate">
            Ref Inv Date <p-sortIcon field="refInvDate"></p-sortIcon>
          </th>
          <th pSortableColumn="itemCode">
            Item <p-sortIcon field="itemCode"></p-sortIcon>
          </th>
          <th pSortableColumn="vendorCatalog">Vendor Catalog</th>
          <th pSortableColumn="unitStandardPrice">
            Unit Standard Price
            <p-sortIcon field="unitStandardPrice"></p-sortIcon>
          </th>
          <th pSortableColumn="unitePrice">
            Unit Price <p-sortIcon field="unitePrice"></p-sortIcon>
          </th>
          <th pSortableColumn="invQty">
            Inv Qty <p-sortIcon field="invQty"></p-sortIcon>
          </th>
          <th pSortableColumn="invAmount">
            Inv Amount <p-sortIcon field="invAmount"></p-sortIcon>
          </th>
          <th pSortableColumn="rebateTrxNumber">
            Rebate Trx Number <p-sortIcon field="rebateTrxNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="rebateTrxDate">
            Rebate Trx Date <p-sortIcon field="rebateTrxDate"></p-sortIcon>
          </th>
          <th pSortableColumn="rebatePercent">
            Rebate Percent <p-sortIcon field="rebatePercent"></p-sortIcon>
          </th>
          <th pSortableColumn="rebateAmount">
            Rebate Amount <p-sortIcon field="rebateAmount"></p-sortIcon>
          </th>
          <th
            pSortableColumn="claimPercent "
            style="width: 22rem; min-width: 22rem"
          >
            Claim Percent <p-sortIcon field="claimPercent"></p-sortIcon>
          </th>
          <th
            pSortableColumn="claimAmount"
            style="width: 22rem; min-width: 22rem"
          >
            Claim Amount <p-sortIcon field="claimAmount"></p-sortIcon>
          </th>
          <th pSortableColumn="claimNumber">
            AP Invoice# <p-sortIcon field="claimNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="claimNumber">
            AP Invoice Date <p-sortIcon field="claimNumber"></p-sortIcon>
          </th>
          <th>Claim Seq#</th>
          <th>AP Gl Segments</th>
          <th>JV Number</th>
          <th>Supplier CN</th>
          <th>JV Reversal Number</th>
          <th>Voucher No</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-contractCalculation>
        <tr>
          <td>
            <ng-container
              *ngIf="
                contractCalculation.claimStatus === 'NEW' ||
                contractCalculation.claimStatus === 'ERROR'
              "
            >
              <p-tableCheckbox [value]="contractCalculation"></p-tableCheckbox>
            </ng-container>
          </td>
          <td>{{ contractCalculation.lineId }}</td>
          <td>{{ contractCalculation.vendorNumber }}</td>
          <td>
            {{ contractCalculation.businessNumber }} -
            {{ contractCalculation.businessName }}
          </td>

          <td>{{ contractCalculation.claimStatus }}</td>
          <td>{{ contractCalculation.claimBatchId }}</td>
          <td>{{ contractCalculation.apErrorMsg }}</td>
          <td>{{ contractCalculation.source }}</td>
          <td>{{ contractCalculation.type }}</td>
          <td>{{ contractCalculation.period }}</td>
          <td>{{ contractCalculation.contractNo }}</td>
          <td>
            {{ contractCalculation.customerNumber }} -
            {{ contractCalculation.customerName }} -
            {{ contractCalculation.billTo }}
          </td>
          <td>{{ contractCalculation.address1 }}</td>
          <td>{{ contractCalculation.address2 }}</td>
          <td>{{ contractCalculation.area }}</td>
          <td>{{ contractCalculation.city }}</td>
          <td>{{ contractCalculation.refInvoice }}</td>
          <td>{{ contractCalculation.refInvDate | date: "yyyy-MM-dd" }}</td>
          <td>
            {{ contractCalculation.itemCode }} -
            {{ contractCalculation.itemDesc }}
          </td>
          <td>{{ contractCalculation.vendorCatalog }}</td>

          <td>{{ contractCalculation.unitStandardPrice }}</td>
          <td>{{ contractCalculation.unitePrice }}</td>
          <td>{{ contractCalculation.invQty }}</td>
          <td>{{ contractCalculation.invAmount }}</td>
          <td>{{ contractCalculation.rebateTrxNumber }}</td>
          <td>{{ contractCalculation.rebateTrxDate | date: "yyyy-MM-dd" }}</td>
          <td>
            {{ contractCalculation.rebatePercent }}
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.rebateUpdatedBy"
            >
              Old:
              {{ contractCalculation.originRebatePercent | number: "1.2-2" }} —
              updated by
              {{
                contractCalculation.rebateUpdatedBy?.fullName ||
                  contractCalculation.rebateUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.rebateUpdatedAt
                  | date: "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>
          <td>
            {{ contractCalculation.rebateAmount }}
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.rebateUpdatedBy"
            >
              Old:
              {{ contractCalculation.originRebateAmount | number: "1.2-2" }} —
              updated by
              {{
                contractCalculation.rebateUpdatedBy?.fullName ||
                  contractCalculation.rebateUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.rebateUpdatedAt
                  | date: "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>
          <td>
            {{ contractCalculation.claimPercent }}
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.claimUpdatedBy"
            >
              Old:
              {{ contractCalculation.originClaimPercent | number: "1.2-2" }} —
              updated by
              {{
                contractCalculation.claimUpdatedBy?.fullName ||
                  contractCalculation.claimUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.claimUpdatedAt | date: "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>

          <td>
            <ng-container
              *ngIf="canEditClaim(contractCalculation); else viewClaimAmount"
            >
              <p-inputgroup>
                <p-inputNumber
                  [mode]="'decimal'"
                  [maxFractionDigits]="2"
                  [showButtons]="true"
                  [ngModel]="
                    claimAmountEdits[contractCalculation.lineId] ??
                    contractCalculation.claimAmt
                  "
                  (ngModelChange)="
                    onClaimAmountChange(contractCalculation.lineId, $event)
                  "
                  [style]="{ width: '8rem' }"
                ></p-inputNumber>
                <p-inputgroup-addon>
                  <p-button
                    icon="pi pi-save"
                    label="Save"
                    [disabled]="savingClaim[contractCalculation.lineId]"
                    [loading]="savingClaim[contractCalculation.lineId]"
                    styleClass="p-button-success p-button-sm"
                    (click)="saveClaimAmount(contractCalculation)"
                  ></p-button>
                </p-inputgroup-addon>
              </p-inputgroup>
            </ng-container>
            <ng-template #viewClaimAmount>
              {{ contractCalculation.claimAmt }}
            </ng-template>
            <div
              class="old-claim-info"
              *ngIf="contractCalculation.claimUpdatedBy"
            >
              Old:
              {{ contractCalculation.originClaimAmount | number: "1.2-2" }} —
              updated by
              {{
                contractCalculation.claimUpdatedBy?.fullName ||
                  contractCalculation.claimUpdatedBy?.email
              }}
              on
              {{
                contractCalculation.claimUpdatedAt | date: "yyyy-MM-dd HH:mm:ss"
              }}
            </div>
          </td>
          <td>{{ contractCalculation.erpApTrxNo }}</td>
          <td>{{ contractCalculation.erpApTrxDate | date: "yyyy-MM-dd" }}</td>
          <td>{{ contractCalculation.claimSeqNumber }}</td>
          <td>
            {{
              contractCalculation.apGlSegment1 +
                " - " +
                contractCalculation.apGlSegment2 +
                " - " +
                contractCalculation.apGlSegment3 +
                " - " +
                contractCalculation.apGlSegment4 +
                " - " +
                contractCalculation.apGlSegment5 +
                " - " +
                contractCalculation.apGlSegment6 +
                " - " +
                contractCalculation.apGlSegment7 +
                " - " +
                contractCalculation.apGlSegment8 +
                " - " +
                contractCalculation.apGlSegment9 +
                " - " +
                contractCalculation.apGlSegment10
            }}
          </td>

          <td>{{ contractCalculation.tracker?.jvTransactionNumber }}</td>
          <td>{{ contractCalculation.tracker?.cnNumber }}</td>
          <td>{{ contractCalculation.tracker?.jvReversedNumber }}</td>
          <td>{{ contractCalculation?.voucherNo }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Data found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-dialog
    header="Extra Info"
    [(visible)]="showPopup"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '50rem' }"
  >
    <form [formGroup]="extraForm">
      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-building"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <p-dropdown
                [fluid]="true"
                [options]="filteredIntendedUses"
                formControlName="intendedUse"
                inputId="intendedUse"
                optionLabel="name"
                optionValue="id"
                class="w-full"
                placeholder="Select Intended Use"
                [required]="true"
              ></p-dropdown>
              <label for="intendedUse">Intended Use</label>
            </p-iftalabel>
            <p-inputgroup-addon
              ><p-button
                type="button"
                icon="pi pi-times"
                (click)="extraForm.controls['intendedUse'].reset()"
                styleClass="p-button-secondary addOnBtnClear"
              ></p-button
            ></p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-building"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <p-dropdown
                [fluid]="true"
                [options]="filteredDocumentCategories"
                formControlName="documentCategory"
                inputId="documentCategory"
                optionLabel="name"
                optionValue="id"
                class="w-full"
                placeholder="Select Document Category"
                [required]="true"
              ></p-dropdown>
              <label for="documentCategory">Document Category</label>
            </p-iftalabel>
            <p-inputgroup-addon
              ><p-button
                type="button"
                icon="pi pi-times"
                (click)="extraForm.controls['documentCategory'].reset()"
                styleClass="p-button-secondary addOnBtnClear"
              ></p-button
            ></p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <!-- trx date required -->
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-calendar"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <p-datePicker
                formControlName="trxDate"
                [showIcon]="true"
                inputId="trxDate"
                class="w-full"
                [appendTo]="'body'"
                [style]="{ width: '100%' }"
              ></p-datePicker>
              <label for="trxDate">Trx Date</label>
            </p-iftalabel>
            <p-inputgroup-addon>
              <p-button
                type="button"
                icon="pi pi-times"
                (click)="extraForm.controls['trxDate'].reset()"
                styleClass="p-button-secondary addOnBtnClear"
              ></p-button>
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon
              ><i class="pi pi-comment"></i
            ></p-inputgroup-addon>
            <p-iftalabel>
              <textarea
                rows="3"
                pInputTextarea
                formControlName="note"
                id="note"
                class="w-full"

              ></textarea>
              <label for="note">Description</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon
              ><i class="pi pi-comment"></i
            ></p-inputgroup-addon>
            <p-iftalabel>
              <textarea
                rows="3"
                pInputTextarea
                formControlName="remark"
                id="remark"
                class="w-full"

              ></textarea>
              <label for="remark">Memo REV JV</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>

      <div class="p-dialog-footer">
        <button
          pButton
          label="Confirm"
          (click)="submitForm('generate')"
        ></button>
        <button
          pButton
          label="Cancel"
          class="p-button-text"
          (click)="showPopup = false"
        ></button>
      </div>
    </form>
  </p-dialog>
  <p-dialog
    header="Reverse JV Booked"
    [(visible)]="showJVReversePopup"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '35rem' }"
  >
    <form [formGroup]="jvReverseForm">
      <div class="grid formgrid p-fluid">
        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-hashtag"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                formControlName="jvReversedNumber"
                id="jvReversedNumber"
                class="w-full"
                placeholder="Enter Reversal JV Trx No"
              />
              <label for="jvReversedNumber">Reversal JV Transaction Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-hashtag"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                formControlName="cnNumber"
                id="cnNumber"
                class="w-full"
                placeholder="Enter CN Number"
              />
              <label for="cnNumber">CN Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
      <div class="p-dialog-footer">
        <button pButton label="Submit" (click)="submitJVReversalBooked()"></button>
        <button
          pButton
          label="Cancel"
          class="p-button-text"
          (click)="showJVReversePopup = false"
        ></button>
      </div>
    </form>
  </p-dialog>
  <p-dialog
    header="JV Booked"
    [(visible)]="showJVPopup"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '35rem' }"
  >
    <form [formGroup]="jvForm">
      <div class="grid formgrid p-fluid">
        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-hashtag"></i>
            </p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                formControlName="jvTransactionNumber"
                id="jvTransactionNumber"
                class="w-full"
                placeholder="Enter JV Trx No"
              />
              <label for="jvTransactionNumber">JV Transaction Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12">
          <p-inputgroup>
            <p-inputgroup-addon
              ><i class="pi pi-comment"></i
            ></p-inputgroup-addon>
            <p-iftalabel>
              <textarea
                rows="3"
                pInputTextarea
                formControlName="description"
                id="jvDescription"
                class="w-full"
               
              ></textarea>
              <label for="jvDescription">Description</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
      <div class="p-dialog-footer">
        <button pButton label="Submit" (click)="submitJVBooked()"></button>
        <button
          pButton
          label="Cancel"
          class="p-button-text"
          (click)="showJVPopup = false"
        ></button>
      </div>
    </form>
  </p-dialog>

  <p-dialog
    header="Credit Memo Contract Report"
    [(visible)]="showPdfPreview"
    [modal]="true"
    [style]="{ width: '70vw', height: '90vh' }"
    [contentStyle]="{ height: '100%' }"
    (onHide)="closePdfPreview()"
  >
    <div *ngIf="pdfLoading" class="flex justify-content-center p-4">
      <p-progress-spinner ariaLabel="loading" />
    </div>
    <p *ngIf="pdfError" style="color: #c0392b">{{ pdfError }}</p>
    <iframe
      *ngIf="pdfUrl && !pdfLoading"
      [src]="pdfUrl"
      title="Credit memo contract report"
      width="100%"
      height="100%"
      style="border: none"
    ></iframe>
  </p-dialog>
</div>
